export const INSTITUTIONS_LIST = 'INSTITUTIONS_LIST'
